import { Position } from "./Position";

class BaseMapObject {
  id!: string;
  name?: string;
}

export class Marker extends BaseMapObject {
  position!: Position;
}

export class Polygon {
  path!: Position[];
}

export class Area extends BaseMapObject {
  paths!: any[];
}
